export default {
  en: {
    agent: 'Agent'
  },
  th: {
    agent: 'ตัวแทน'
  }
}
